import { AUTHENTICATION } from "config/apiEndPoint";
import { GET_SSO, POST_SSO } from "config/api.config";
import { SSO_APPLICATION, buildSsoChallengeUrl } from "helpers/ssoApiBase";

export const SSO_ERROR_MESSAGES = {
  no_account:
    "No ATS account is linked to this identity. Please contact your administrator.",
  unauthorized: "You are not authorized to access the ATS.",
  invalid_state:
    "Your sign-in session expired or was tampered with. Please try again.",
  invalid_request: "The sign-in request was incomplete. Please try again.",
  provider_error: "Microsoft declined the sign-in request.",
  provider_unavailable:
    "Microsoft Entra ID is currently unavailable. Please try password login instead.",
  authentication_failed:
    "Your identity could not be verified. Please try again.",
  sso_disabled: "SSO is not currently enabled.",
};

export const resolveSsoErrorMessage = (errorCodeOrMessage) => {
  if (!errorCodeOrMessage) {
    return "Sign-in failed. Please try again.";
  }
  const key = String(errorCodeOrMessage).trim();
  return SSO_ERROR_MESSAGES[key] ?? key;
};

export const getSsoStatus = async () => {
  try {
    const response = await GET_SSO(AUTHENTICATION.SSO_STATUS);
    if (response?.success === false) {
      return { enabledProviders: [] };
    }
    const payload = response?.data ?? response;
    const enabledProviders = payload?.enabledProviders ?? [];
    return { enabledProviders: Array.isArray(enabledProviders) ? enabledProviders : [] };
  } catch {
    return { enabledProviders: [] };
  }
};

export const exchangeSsoCode = async (code) => {
  const response = await POST_SSO(AUTHENTICATION.SSO_EXCHANGE, { code });
  return response;
};

/** GET challenge — `?application=frontend` (ATS web app). */
export const startSsoChallenge = (providerKey) => {
  const url = buildSsoChallengeUrl(providerKey, {
    application: SSO_APPLICATION,
  });
  if (url) {
    window.location.href = url;
  }
};

export const redirectToSsoChallenge = startSsoChallenge;
